// src/app/components/checkout/services/payment-result.service.ts

import { Injectable, signal, inject, computed } from '@angular/core';
import { PaymentResult } from '../models/payment-result.interface';
import { AppConfigService, Log } from '@core/services/config/app-config.service';
import { UserStoreService } from '@core/services/storage/user/user-store.service';

const STORAGE_KEY = 'emp_payment_result';

@Injectable({
    providedIn: 'root'
})
export class PaymentResultService {
    private appConfig = inject(AppConfigService);
    
    // ==========================================
    // STATE con signals
    // ==========================================
    private _result = signal<PaymentResult | null>(null);
    readonly result = this._result.asReadonly();

    isGuest = computed(() => {
        if(this._result()?.order_data) {
            if(this._result()?.order_data?.is_guest) {
                return true;
            }
        }

        return false;
    });

    userStoreService = inject(UserStoreService);

    constructor() {
        // Recupera da sessionStorage al caricamento
        this.loadFromStorage();
    }

    /**
     * Imposta il risultato e persiste in sessionStorage
     */
    setResult(result: PaymentResult): void {

        // se user è guest imposto il flag is_guest
        if(this.userStoreService.isGuest()) {
            if(result.order_data) {
                result.order_data.is_guest = true;
            }
        }


        this._result.set(result);
        this.saveToStorage(result);
    }

    /**
     * Pulisce il risultato e rimuove da sessionStorage
     */
    clear(): void {
        this._result.set(null);
        this.removeFromStorage();
    }

    /**
     * Verifica se c'è un risultato valido
     */
    hasResult(): boolean {
        return this._result() !== null;
    }

    // === PRIVATE METHODS ===

    private loadFromStorage(): void {
        if (!this.appConfig.cli()) return;

        try {
            const stored = sessionStorage.getItem(STORAGE_KEY);
            if (stored) {
                const result = JSON.parse(stored) as PaymentResult;
                this._result.set(result);
            }
        } catch (e) {
            Log.error('Error loading payment result from storage', e);
            this.removeFromStorage();
        }
    }

    private saveToStorage(result: PaymentResult): void {
        if (!this.appConfig.cli()) return;

        try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(result));
        } catch (e) {
            Log.error('Error saving payment result to storage', e);
        }
    }

    private removeFromStorage(): void {
        if (!this.appConfig.cli()) return;

        try {
            sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {
            Log.error('Error removing payment result from storage', e);
        }
    }
}